
import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import Infrastructure from "./pages/Infrastructure";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import History from "./pages/History";
import Home from "./pages/Home";
import AboutSchool from "./pages/AboutSchool";
import SchoolManagement from "./pages/SchoolManagement";
import TeacherList from "./pages/TeacherList";
import Courses from "./pages/Courses";
import AdmissionForm from "./pages/AdmissionForm";
import Contact from "./pages/Contact";
function App() {
  return (
    <BrowserRouter>
      <Navbar />

      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<AboutSchool />} />
          <Route path="/history" element={<History />} />
          <Route path="/teacher-list" element={<TeacherList />} />
          <Route path="/infrastructure" element={<Infrastructure />} />
          <Route path="/school-management" element={<SchoolManagement />} />
          <Route path="/courses" element={<Courses />} />
          <Route path="/admission-form" element={<AdmissionForm />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </main>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
